import { render, staticRenderFns } from "./Step1Configuration.vue?vue&type=template&id=6fcfb050&scoped=true&"
import script from "./Step1Configuration.vue?vue&type=script&lang=js&"
export * from "./Step1Configuration.vue?vue&type=script&lang=js&"
import style0 from "./Step1Configuration.vue?vue&type=style&index=0&id=6fcfb050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcfb050",
  null
  
)

export default component.exports